import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from 'LuxKit/Button/TextButton'
import ContactContext from 'contexts/contactContext'

function CruiseSupportButton() {
  const currentContact = useContext(ContactContext)
  const contact = currentContact.defaultContact

  return <TextButton
    kind="secondary"
    fit="full-width"
    startIcon={<LinePhoneIcon />}
    href={`tel:${contact.number}`}
  >
    <FormattedMessage
      id="5tFQ303TFI"
      defaultMessage="Call {phoneNumber}"
      description="Button text to call support with phone number"
      values={{ phoneNumber: contact.humanReadable }}
    />
  </TextButton>
}

export default CruiseSupportButton
